import { PayloadAction } from '@reduxjs/toolkit';

import { AppState, SlotLayoutBuilderState } from 'editor/src/store/app/types';

const setSlotFolderPickReducer = (
  state: AppState,
  { payload }: PayloadAction<SlotLayoutBuilderState['folderPick'] | undefined>,
) => {
  if (state.slotLayoutBuilder) {
    state.slotLayoutBuilder.folderPick = payload;
  }
};

export default setSlotFolderPickReducer;
